import { Parser } from 'html-to-react'
import { Button } from 'primereact/button'
import { useEffect, useRef, useState, type ReactElement } from 'react'

export type ReadMorePropsType = {
  title: string
  textUrl: string | undefined
}

export function ReadMore(props: ReadMorePropsType): ReactElement {
  const textRef = useRef<HTMLSpanElement>(null)
  const containerRef = useRef<HTMLDivElement>(null)

  const [openReadMore, setOpenReadMore] = useState<boolean>(false)
  const [showButton, setShowButton] = useState<boolean>(false)
  const [maxHeight, setMaxHeight] = useState<number>(0)

  const MAX_HEIGHT = 2 // Numero fisso di righe da mostrare quando compresso

  useEffect(() => {
    const checkOverflow = () => {
      if (textRef.current && containerRef.current && props.textUrl) {
        const originalMaxHeight = containerRef.current.style.maxHeight
        const originalOverflow = containerRef.current.style.overflow

        containerRef.current.style.maxHeight = 'none'
        containerRef.current.style.overflow = 'visible'

        const lineHeight = parseInt(window.getComputedStyle(containerRef.current).lineHeight)

        const calculatedMaxHeight = MAX_HEIGHT * lineHeight
        setMaxHeight(calculatedMaxHeight)

        const actualHeight = containerRef.current.scrollHeight

        setShowButton(actualHeight > calculatedMaxHeight)

        containerRef.current.style.maxHeight = originalMaxHeight
        containerRef.current.style.overflow = originalOverflow
      }
    }

    const timer = setTimeout(checkOverflow, 100)

    window.addEventListener('resize', checkOverflow)

    return () => {
      clearTimeout(timer)
      window.removeEventListener('resize', checkOverflow)
    }
  }, [props.textUrl, openReadMore])

  return (
    <li className='mb-[10px] text-[16px] leading-[24px]'>
      <div
        ref={containerRef}
        className={
          !openReadMore
            ? 'overflow-hidden [&_a:hover]:text-blue-800 [&_a]:text-blue-600 [&_a]:underline'
            : '[&_a:hover]:text-blue-800 [&_a]:text-blue-600 [&_a]:underline'
        }
        style={!openReadMore ? { maxHeight: `${maxHeight}px` } : {}}
      >
        <b className='pr-[2px]'>{props.title}: </b>
        <span ref={textRef}>{Parser().parse(props.textUrl!)}</span>
      </div>
      {showButton && (
        <Button
          text
          tabIndex={0}
          pt={{
            root: {
              className: 'm-0 p-0 underline',
            },
          }}
          aria-expanded={openReadMore}
          aria-label={openReadMore ? 'Riduci' : 'Continua a leggere'}
          label={openReadMore ? 'Riduci' : 'Continua a leggere'}
          onClick={() => setOpenReadMore((x) => !x)}
        ></Button>
      )}
    </li>
  )
}
